import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import MuiSearchSelect from "../basicComponent/MuiSearchSelect";
import { MuiInput } from "../basicComponent/MuiInput";
import MuiDatePicker from "../basicComponent/MuiDatePicker";
import dayjs, { Dayjs } from "dayjs";
import { FaMinus, FaPlus } from "react-icons/fa";
import MuiButton from "../basicComponent/MuiButton";
import { Box, Checkbox, Tab, Tabs, TextField, Typography } from "@mui/material";
import UserListFilter from "./UserListFilter";
import { UtilService } from "../../services/shared/UtilService";
import {
  AirportType,
  Category,
  categoryType,
  CRSName,
  fareType,
  flatType,
  flightClass,
  flightOptions,
  List,
  percentageType,
  validFor,
} from "../../constants/constant";
import { hasAnyValue, deepOmit } from "../../constants/helper";
import { msgTypes } from "../../constants/msgTypes";
import { date } from "yup";
import { MuiDropDown } from "../basicComponent/MuiDropDown";
import { CreateCommissionSchema } from "../../validations/Schema";
import MuiMultiSelect from "../basicComponent/MuiMultiSelect";
import ConfirmationModal from "../basicComponent/ConfirmationModal";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type CMFilterPopUpProps = {
  index: number | null;
  setOpen: (value: boolean) => void;
  flightOptions: { label: string; value: string }[];
};

export const AddCommission = () => {
  const sectionRef = useRef<HTMLDivElement>(null); // ✅ specify the type
  const [rowToDelete, setRowToDelete] = useState<{
    id: any;
    index: number;
  } | null>(null);
  const submitRowIndexRef = useRef<number | null>(null);

  const airportRef = useRef<HTMLInputElement>(null);
  const [airportList, setAirportList] = useState<List[]>([]);
  const [showRejectConfirmation, setShowRejectConfirmation] =
    useState<boolean>(false);
  const [checkValidAirport, setCheckValidAirport] = useState<boolean>(false);
  const [popupIndex, setPopupIndex] = useState<number | null>(null);
  const [commissionId, setCommissionId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [commissions, setCommissions] = useState<any[]>([]);
  const [airlineOptions, setAirlineOptions] = useState<any>({});
  const [airlineSearch, setAirlineSearch] = useState<Record<number, string>>(
    {}
  );

  const [countryCodeList, setCountryCodeList] = useState([]);
  const [editingRowIndex, setEditingRowIndex] = useState<number | null>(null);

  const [categoriesList, setCategoriesList] = useState([
    {
      label: "Add new Category",
      value: "Add new Category",
      id: -1,
    },
  ]);

  const handleScroll = () => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const { showSuccess, showError } = useSweetAlert();
  useEffect(() => {
    getCountryCodeList();
  }, []);

  const getCountryCodeList = async () => {
    try {
      const res = await UtilService.getCountryCodeList();
      const data =
        res?.data?.map((i: { countryName: string }) => ({
          label: i?.countryName,
          value: i?.countryName,
        })) || [];

      setCountryCodeList(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleOpen = (index: number) => {
    setPopupIndex(index);
    setOpen(true);
  };
  const handleClose = () => {
    setPopupIndex(null);
    setOpen(false);
  };

  const initialValues = {
    category: "",
    categoryName: "",
    commissions: [
      {
        categoryId: "",
        commissionType: "",
        crsName: "",
        airport: "",
        airportCategory: "",
        airlineCodes: [],
        cabin: "",
        flatType: "",
        fareType: "",
        perType: "", //  "perType": "BF",
        per: "",
        adultChildValue: "",
        infantValue: "",
        validUpto: "",
        validFor: "",
        // conditions: [
        //   {
        //     id: "",
        //     conditionType: "",
        //     originCodes: [],
        //     destinationCodes: [],
        //     code: "",
        //     sector: "",
        //     rbd: "",
        //     operatingCarriers: "",
        //     flights: "",
        //     fareDescription: "",
        //   },
        //   {
        //     conditionType: "",
        //     originCodes: [],
        //     destinationCodes: [],
        //     code: "",
        //     sector: "",
        //     rbd: "",
        //     operatingCarriers: "",
        //     flights: "",
        //     fareDescription: "",
        //   },
        // ],

        dateValidation: {
          salesValidFrom: "",
          salesValidTo: "",
          travelValidFrom: "",
          travelValidTo: "",
        },
        otherOptions: {
          id: "",
          tripType: "",
          connectingFlight: false,
          via: false,
        },
        destinationCountries: [],
        originCountries: [],
        originCodes: [],
        destinationCodes: [],
        isNew: true as boolean | undefined,
      },
    ],
  };

  const defaultCommissionRow = {
    categoryId: "",
    commissionType: "",
    crsName: "",
    airport: "",
    airportCategory: "",
    airlineCodes: [],
    cabin: "",
    flatType: "",
    fareType: "",
    perType: "",
    per: "",
    adultChildValue: 0,
    infantValue: 0,
    validUpto: "",
    validFor: "",
    // conditions: [
    //   {
    //     id: "",
    //     conditionType: "",
    //     originCodes: [],
    //     destinationCodes: [],
    //     code: "",
    //     sector: "",
    //     rbd: "",
    //     operatingCarriers: "",
    //     flights: "",
    //     fareDescription: "",
    //   },
    //   {
    //     conditionType: "",
    //     originCodes: [],
    //     destinationCodes: [],
    //     code: "",
    //     sector: "",
    //     rbd: "",
    //     operatingCarriers: "",
    //     flights: "",
    //     fareDescription: "",
    //   },
    // ],
    dateValidation: {
      salesValidFrom: "",
      salesValidTo: "",
      travelValidFrom: "",
      travelValidTo: "",
    },
    otherOptions: {
      id: "",
      tripType: "",
      connectingFlight: false,
      via: false,
    },
    destinationCountries: [],
    originCountries: [],
    originCodes: [],
    destinationCodes: [],
    isNew: true,
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: CreateCommissionSchema,
    onSubmit: async (values) => {
      const index = submitRowIndexRef.current;
      if (index === null) return;

      const row = values.commissions[index];
      const origin = row.originCountries ?? [];
      const destination = row.destinationCountries ?? [];

      const isDomestic = row.airport === "Dom.";
      const isInternational = row.airport === "Intl.";
      const hasCommonCountry = origin.some((country) =>
        destination.includes(country)
      );
      if (
        (origin?.length > 0 && isDomestic && !hasCommonCountry) ||
        (origin?.length > 0 && isInternational && hasCommonCountry)
      ) {
        setCheckValidAirport(true);
        return;
      }

      if (row.isNew && values.category === "Add new Category") {
        await addCommission(); // This will internally call AddMarkup if needed
        return;
      }

      if (
        row.isNew &&
        values.category !== "Add new Category" &&
        hasAnyValue(values.commissions ?? [])
      ) {
        await AddMarkup(commissionId, index);
      } else {
        await updateCommissionRow(index, row.categoryId); // update existing
        setEditingRowIndex(null);
      }

      submitRowIndexRef.current = null;
    },
  });

  const getFlightCommissionInfo = async (id: number | null) => {
    try {
      // const response = await UtilService.getFlightCommissionData(id);
      const response = await UtilService.tempcategory(id);
      const fetchedCommissions = response?.data ?? [];
      const mapped = fetchedCommissions.length
        ? fetchedCommissions.map((item: any) => ({
            ...defaultCommissionRow,
            ...item,
            categoryId: item.category ?? "",
            // conditions: [0, 1].map((i) => ({
            //   ...defaultCommissionRow.conditions[i],
            //   ...(item.conditions?.[i] || {}),
            // })),
            dateValidation: {
              ...defaultCommissionRow.dateValidation,
              ...(item.dateValidation || {}),
            },
            otherOptions: {
              ...defaultCommissionRow.otherOptions,
              ...(item.otherOptions || {}),
            },
            isNew: false,
          }))
        : [defaultCommissionRow]; // fallback to default if empty

      setCommissions(mapped);
      formik.setFieldValue("commissions", mapped);
    } catch (error) {
      console.error("Error fetching flight commission info:", error);
      setCommissions([defaultCommissionRow]);
      formik.setFieldValue("commissions", [defaultCommissionRow]);
    }
  };

  useEffect(() => {
    getCategoriesList();
  }, []);

  const getCategoriesList = async () => {
    try {
      const res = await UtilService.categoriesList();
      if (!!res) {
        const data =
          res.data?.map((i: { name: string; id: number }) => ({
            label: i?.name,
            value: i?.name,
            id: i?.id,
          })) || [];

        setCategoriesList((prev) => [
          { label: "Add new Category", value: "Add new Category", id: -1 },
          ...data,
        ]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  useEffect(() => {
    const timers: Record<number, NodeJS.Timeout> = {};

    Object.entries(airlineSearch).forEach(([indexStr, searchValue]) => {
      const index = Number(indexStr);

      if (searchValue.length >= 3) {
        timers[index] = setTimeout(async () => {
          try {
            const res = await UtilService.getAirlineList(searchValue);
            if (res?.statusMsg === msgTypes.SUCCESS.msg) {
              const formatted = res.data.map((i: any) => ({
                label: i.name,
                value: i.iata_code,
              }));
              setAirlineOptions((prev: any) => ({
                ...prev,
                [index]: formatted,
              }));
            }
          } catch (err) {
            console.error(`Error fetching airlines for row ${index}`, err);
          }
        }, 500);
      }
    });

    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, [airlineSearch]);

  const addCommission = async () => {
    const payload = {
      name: formik.values.categoryName,
    };
    try {
      const res = await UtilService.createCommission(payload);
      if (res?.statusMsg === msgTypes?.SUCCESS.msg) {
        const hasFilledMarkUp = hasAnyValue(formik.values.commissions ?? []);
        if (hasFilledMarkUp) {
          setCommissionId(res?.data?.id);
          AddMarkup(res?.data?.id);
        }
      }
    } catch (error) {
      console.log("error while adding commission", error);
    }
  };

  // const updateCommission = async () => {
  //   const payload = {
  //     commissions: formik.values?.commissions
  //       ?.map((i) =>
  //         cleanFilledFields({
  //           ...i,
  //           categoryId: commissionId,
  //         })
  //       )
  //       .filter(Boolean),
  //   };
  //   try {
  //     const response = await UtilService.updateFlightCommission(payload);

  //     console.log("response", response);
  //   } catch (error) {
  //     console.error("Error updating commission:", error);
  //   }
  // };

  useEffect(() => {
    getAirportList();
  }, []);

  const getAirportList = async () => {
    try {
      const response = await UtilService.getAirport();
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        const arr = response?.data?.map(
          (i: { airportName: any; airportCode: any }) => ({
            label: i?.airportName,
            value: i?.airportName,
            code: i?.airportCode,
          })
        );
        setAirportList(arr);
      }
    } catch (error) {
      console.error("Error fetching airport list:", error);
    }
  };

  function cleanFilledFields(obj: any): any {
    if (Array.isArray(obj)) {
      const cleanedArray = obj
        .map(cleanFilledFields)
        .filter(
          (item) =>
            !(
              item == null ||
              (typeof item === "object" && Object.keys(item).length === 0)
            )
        );
      return cleanedArray.length > 0 ? cleanedArray : undefined;
    }

    if (typeof obj === "object" && obj !== null) {
      const cleanedObj = Object.entries(obj).reduce(
        (acc: any, [key, value]) => {
          const cleanedValue = cleanFilledFields(value);
          const shouldKeep = !(
            cleanedValue === "" ||
            cleanedValue === null ||
            cleanedValue === undefined ||
            cleanedValue === false ||
            (typeof cleanedValue === "object" &&
              Object.keys(cleanedValue).length === 0)
          );

          if (shouldKeep) acc[key] = cleanedValue;
          return acc;
        },
        {}
      );

      return Object.keys(cleanedObj).length > 0 ? cleanedObj : undefined;
    }

    return obj;
  }

  const AddMarkup = async (categoryId: number | null, index?: number) => {
    const firstCommission = formik.values?.commissions?.[index ?? 0];

    const payload =
      firstCommission && Object.keys(firstCommission).length > 0
        ? cleanFilledFields({
            ...firstCommission,
            categoryId,
          })
        : null;

    try {
      const res = await UtilService.commissionRule(payload);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        formik.resetForm();
        showSuccess("Success!", "Commission Rule has been added successfully.");
        getCategoriesList();
      } else {
        showError(
          "Oops...",
          res.statusRemark ??
            "Something went wrong while adding commission rule!"
        );
      }
    } catch (error) {
      console.log("error while adding AddCommissionRule", error);
    }
  };

  const handleAddRow = () => {
    const newCommission = JSON.parse(
      JSON.stringify(initialValues.commissions[0])
    );
    newCommission.isNew = true; // ✅ Mark it as a newly added row

    formik.setFieldValue("commissions", [
      ...formik.values.commissions,
      newCommission,
    ]);
  };
  const removeCommissionRow = async (id: number, index: number) => {
    const response = await UtilService.removeFlightCommissionData(id);
    if (!!response) {
      handleRemoveRow(index);
      setShowRejectConfirmation(false);
    }
  };

  const handleRemoveRow = (index: number) => {
    const updated = [...formik.values.commissions];
    updated.splice(index, 1);
    formik.setFieldValue("commissions", updated);
    setShowRejectConfirmation(false);
  };

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }
  // ✅ Fixed version of CMFilterPopUp with flat mapping for cmFormik
  const CMFilterPopUp = ({
    index,
    flightOptions,
    setOpen,
  }: CMFilterPopUpProps) => {
    const [value, setValue] = React.useState(0);
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const [isVisibleDestinationModal, setIsVisibleDestinationModal] =
      useState<boolean>(false);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
    const getOriginCodeList = async (country: string[], field: string) => {
      const countriesParam = country.join(",");
      try {
        const res = await UtilService.getOriginCodeByCountry(countriesParam);
        cmFormik.setFieldValue(field, res?.data);
      } catch (error) {
        console.log("error inside get orgin code by list", error);
      }
    };
    const cmFormik = useFormik({
      initialValues:
        index !== null
          ? JSON.parse(JSON.stringify(formik.values.commissions[index]))
          : {},
      enableReinitialize: true,
      onSubmit(values) {
        // const isConditionFilled = (conditions: any) =>
        //   Object.values(conditions).some(
        //     (val) => val !== null && val !== undefined && val !== ""
        //   );

        // if (isConditionFilled(values.conditions?.[0])) {
        //   values.conditions[0].conditionType = "include";
        // }
        // if (isConditionFilled(values.conditions?.[1])) {
        //   values.conditions[1].conditionType = "exclude";
        // }

        if (index !== null) {
          const updatedList = [...formik.values.commissions];
          updatedList[index] = values;
          formik.setFieldValue("commissions", updatedList);
        }
        setOpen(false);
      },
    });
    const [selectedOriginCountry, setSelectedOriginCountry] = useState<
      string[]
    >(cmFormik.values.originCountries ?? []);
    const [selectDestinationCountry, setSelectedDestinationCountry] = useState<
      string[]
    >(cmFormik.values.destinationCountries ?? []);

    return (
      <>
        <div className="">
          <div className="row align-items-center assign-commission-tabs">
            <Box
              sx={{
                flexGrow: 1,
                bgcolor: "background.paper",
                display: "flex",
                height: 250,
              }}
            >
              <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{
                  borderRight: 1,
                  borderColor: "divider",
                  overflow: "visible",
                }}
              >
                {/* <Tab label="Include" {...a11yProps(0)} />
                  <Tab label="Exclude" {...a11yProps(1)} /> */}
                <Tab label="Date Validation" {...a11yProps(0)} />
                <Tab label="Other Options" {...a11yProps(1)} />
                <Tab label="Sector" {...a11yProps(2)} />
              </Tabs>
              <Box>
                {/* <TabPanel value={value} index={0}>
                    <div className="row">
                      <div className="col-md-4">
                        <MuiMultiSelect
                          label="Origin"
                          options={airportList}
                          onChange={(val) => {
                            cmFormik.setFieldValue(
                              `conditions[0].originCodes`,
                              val
                            );
                          }}
                          value={
                            cmFormik.values.conditions?.[0]?.originCodes || []
                          }
                          placeholder="Origin"
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiMultiSelect
                          label="Destination"
                          options={airportList}
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[0].destinationCodes",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[0]?.destinationCodes ||
                            []
                          }
                          placeholder={"Destination"}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          placeholder="Code"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[0].code", val)
                          }
                          value={cmFormik.values.conditions?.[0]?.code}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Sector"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[0].sector", val)
                          }
                          value={cmFormik.values.conditions?.[0]?.sector}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="RBD"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[0].rbd", val)
                          }
                          value={cmFormik.values.conditions?.[0].rbd}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Operating Carriers"
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[0].operatingCarriers",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[0]?.operatingCarriers
                          }
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Flights"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[0].flights", val)
                          }
                          value={cmFormik.values.conditions?.[0]?.flights}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Fare Description"
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[0].fareDescription",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[0]?.fareDescription
                          }
                        />
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel value={value} index={1}>
                    <div className="row">
                      <div className="col-md-4">
                        <MuiMultiSelect
                          label="Origin"
                          options={airportList}
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[1].originCodes",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[1].originCodes || []
                          }
                          placeholder={"Origin"}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiMultiSelect
                          label="Destination"
                          options={airportList}
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[1].destinationCodes",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[1].destinationCodes ||
                            []
                          }
                          placeholder={"Destination"}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          placeholder="Code"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[1].code", val)
                          }
                          value={cmFormik.values.conditions?.[1].code}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Sector"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[1].sector", val)
                          }
                          value={cmFormik.values.conditions?.[1].sector}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="RBD"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[1].rbd", val)
                          }
                          value={cmFormik.values.conditions?.[1].rbd}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Operating Carriers"
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[1].operatingCarriers",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[1].operatingCarriers
                          }
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Flights"
                          onChange={(val) =>
                            cmFormik.setFieldValue("conditions[1].flights", val)
                          }
                          value={cmFormik.values.conditions?.[1].flights}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder="Fare Description"
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "conditions[1].fareDescription",
                              val
                            )
                          }
                          value={
                            cmFormik.values.conditions?.[1].fareDescription
                          }
                        />
                      </div>
                    </div>
                  </TabPanel> */}

                <TabPanel value={value} index={0}>
                  <div className="row">
                    {/* <div className="col-md-6">
                        <MuiDatePicker
                          label="Sales Valid From"
                          value={
                            cmFormik.values.dateValidation?.salesValidFrom
                              ? dayjs(
                                  cmFormik.values.dateValidation?.salesValidFrom
                                )
                              : null
                          }
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "dateValidation.salesValidFrom",
                              val
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6">
                        <MuiDatePicker
                          label="Sales Valid To"
                          value={
                            cmFormik.values.dateValidation?.salesValidTo
                              ? dayjs(
                                  cmFormik.values.dateValidation?.salesValidTo
                                )
                              : null
                          }
                          onChange={(val) =>
                            cmFormik.setFieldValue(
                              "dateValidation.salesValidTo",
                              val
                            )
                          }
                        />
                      </div> */}
                    <div className="col-md-6 mt-3">
                      <MuiDatePicker
                        label="Travel Valid From"
                        value={
                          cmFormik.values.dateValidation?.travelValidFrom
                            ? dayjs(
                                cmFormik.values.dateValidation?.travelValidFrom
                              )
                            : null
                        }
                        onChange={(val) =>
                          cmFormik.setFieldValue(
                            "dateValidation.travelValidFrom",
                            val
                          )
                        }
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <MuiDatePicker
                        label="Travel Valid To"
                        value={
                          cmFormik.values.dateValidation?.travelValidTo
                            ? dayjs(
                                cmFormik.values.dateValidation?.travelValidTo
                              )
                            : null
                        }
                        onChange={(val) => {
                          cmFormik.setFieldValue(
                            "dateValidation.travelValidTo",
                            val
                          );
                          cmFormik.setFieldValue("validUpto", val);
                        }}
                      />
                    </div>
                  </div>
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <div className="row">
                    <div className="col-md-12">
                      <MuiSearchSelect
                        label="Trip"
                        options={flightOptions}
                        onChange={(val) =>
                          cmFormik.setFieldValue("otherOptions.tripType", val)
                        }
                        value={cmFormik.values.otherOptions?.tripType}
                        placeholder={""}
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <Checkbox
                        checked={cmFormik.values.otherOptions?.connectingFlight}
                        onChange={() =>
                          cmFormik.setFieldValue(
                            "otherOptions.connectingFlight",
                            !cmFormik.values.otherOptions?.connectingFlight
                          )
                        }
                      />
                      <label>Connecting Flight</label>
                    </div>
                    <div className="col-md-6 mt-3">
                      <Checkbox
                        checked={cmFormik.values.otherOptions?.via}
                        onChange={() =>
                          cmFormik.setFieldValue(
                            "otherOptions.via",
                            !cmFormik.values.otherOptions?.via
                          )
                        }
                      />
                      <label>Via</label>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <div className="row">
                    <div className="col-md-12">
                      <span
                        onClick={() => setIsVisible(true)}
                        className="text-primary text-sm cursor-pointer text-decoration-underline"
                      >
                        Select Country Code
                      </span>
                      <ConfirmationModal
                        handleClose={() => setIsVisible(false)}
                        header="Country Code"
                        isVisible={isVisible}
                        onConfirm={() => {
                          getOriginCodeList(
                            selectedOriginCountry,
                            "originCodes"
                          );
                          setIsVisible(false);
                        }}
                        children={
                          <>
                            {formik.values.commissions?.[index ?? 0].airport ===
                            "Dom." ? (
                              <MuiSearchSelect
                                onChange={(value) => {
                                  setSelectedOriginCountry([value]);
                                  cmFormik.setFieldValue("originCountries", [
                                    value,
                                  ]);
                                }}
                                options={countryCodeList}
                                placeholder="Select Country"
                                value={selectedOriginCountry?.[0]}
                              />
                            ) : (
                              <MuiMultiSelect
                                options={countryCodeList}
                                onChange={(value) => {
                                  setSelectedOriginCountry(value);
                                  cmFormik.setFieldValue(
                                    "originCountries",
                                    value
                                  );
                                }}
                                value={selectedOriginCountry}
                                placeholder="Select Some Options"
                              />
                            )}
                          </>
                        }
                      />
                      <div className="mt-2">
                        <MuiInput
                          label="Origin"
                          value={cmFormik.values.originCodes || ""}
                          onChange={(value: string) =>
                            cmFormik.setFieldValue("originCodes", value)
                          }
                          placeholder="Origin"
                        />
                      </div>
                    </div>
                    <div className="col-md-12 mt-4">
                      <span
                        onClick={() => setIsVisibleDestinationModal(true)}
                        className="text-primary text-sm cursor-pointer  text-decoration-underline"
                      >
                        Select Country Code
                      </span>
                      <ConfirmationModal
                        handleClose={() => setIsVisibleDestinationModal(false)}
                        header="Country Code"
                        isVisible={isVisibleDestinationModal}
                        onConfirm={() => {
                          getOriginCodeList(
                            selectDestinationCountry,
                            "destinationCodes"
                          );
                          setIsVisibleDestinationModal(false);
                        }}
                        children={
                          <>
                            {formik.values.commissions?.[index ?? 0].airport ===
                            "Dom." ? (
                              <MuiSearchSelect
                                onChange={(value) => {
                                  setSelectedDestinationCountry([value]);
                                  cmFormik.setFieldValue(
                                    "destinationCountries",
                                    [value]
                                  );
                                }}
                                options={countryCodeList}
                                placeholder="Select Country"
                                value={selectDestinationCountry?.[0]}
                              />
                            ) : (
                              <MuiMultiSelect
                                options={countryCodeList}
                                onChange={(value) => {
                                  setSelectedDestinationCountry(value);
                                  cmFormik.setFieldValue(
                                    "destinationCountries",
                                    value
                                  );
                                }}
                                value={selectDestinationCountry}
                                placeholder="Select Some Options"
                              />
                            )}
                          </>
                        }
                      />
                      <div className="mt-2">
                        <MuiInput
                          label="Destination"
                          value={cmFormik.values.destinationCodes || ""}
                          onChange={(value: string) =>
                            cmFormik.setFieldValue("destinationCodes", value)
                          }
                          isInvalid={
                            selectedOriginCountry?.length > 0 &&
                            selectDestinationCountry?.length > 0 &&
                            formik.values.commissions?.[index ?? 0].airport ===
                              "Dom."
                              ? !selectedOriginCountry.some((country) =>
                                  selectDestinationCountry.includes(country)
                                )
                              : formik.values.commissions?.[index ?? 0]
                                  .airport === "Intl."
                              ? selectedOriginCountry.some((country) =>
                                  selectDestinationCountry.includes(country)
                                )
                              : false
                          }
                          errorText={
                            selectedOriginCountry?.length > 0 &&
                            selectDestinationCountry?.length > 0 &&
                            formik.values.commissions?.[index ?? 0].airport ===
                              "Dom." &&
                            !selectedOriginCountry.some((country) =>
                              selectDestinationCountry.includes(country)
                            )
                              ? "Please Select Valid destination Codes"
                              : formik.values.commissions?.[index ?? 0]
                                  .airport === "Intl." &&
                                selectedOriginCountry.some((country) =>
                                  selectDestinationCountry.includes(country)
                                )
                              ? "Please Select Valid destination Codes"
                              : ""
                          }

                          // placeholder="Destination"
                        />
                      </div>
                      {/* <MuiInput
                        label="Destination"
                        // options={airportList}
                        onChange={(val) =>
                          cmFormik.setFieldValue("destinationCodes", val)
                        }
                        value={cmFormik.values.destinationCodes || []}
                        placeholder={"Destination"}
                      /> */}
                    </div>
                  </div>
                </TabPanel>
              </Box>
            </Box>
          </div>
          <div className="user-button w-full mt-2 ms-5">
            <MuiButton
              className="clear-btn"
              label="Close"
              onClick={() => setOpen(false)}
            />
            <MuiButton
              className="get-btn"
              label="Submit"
              onClick={() => {
                cmFormik.handleSubmit();
              }}
              disabled={
                formik.values.commissions?.[index ?? 0].airport === "Dom."
                  ? !selectedOriginCountry.some((country) =>
                      selectDestinationCountry.includes(country)
                    )
                  : formik.values.commissions?.[index ?? 0].airport === "Intl."
                  ? selectedOriginCountry.some((country) =>
                      selectDestinationCountry.includes(country)
                    )
                  : false
              }
            />
          </div>
        </div>
      </>
    );
  };

  const updateCommissionRow = async (index: number, id: any) => {
    const rowData = deepOmit(
      cleanFilledFields(formik.values.commissions[index]),
      ["id", "category", "categoryId"]
    );

    try {
      const response = await UtilService.updateFlightCommission(rowData, id); // API call to add
      // toast.success("New commission added");
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess(
          "Success!",
          "Commission Rule has been updated successfully."
        );
      } else {
        showError(
          "Oops...",
          response.statusRemark ??
            "Something went wrong while updating commission rule!"
        );
      }
      const updatedRows = [...formik.values.commissions];
      delete updatedRows[index].isNew; // remove the isNew flag
      formik.setFieldValue("commissions", updatedRows);
    } catch (error) {
      console.error("Failed to add:", error);
      // toast.error("Failed to save new commission");
    }
  };

  const saveNewRow = async () => {
    const commissionRow = {
      ...cleanFilledFields(formik.values.commissions),
      categoryId: commissionId, // it is categorty id
    };

    const rowData = {
      commissions: [commissionRow],
    };
    try {
      const res = await UtilService.commissionRule(rowData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        formik.resetForm();
      }
    } catch (error) {
      console.log("error while adding AddCommissionRule", error);
    }
  };

  return (
    <div className="row mt-4">
      <div className="col-md-4 mb-3 mb-md-0">
        <MuiSearchSelect
          label="Assigned Category"
          onChange={(value, id) => {
            formik.setFieldValue("category", value);
            // formik.setFieldTouched("category", true);

            if (value === "Add new Category") {
              formik.setFieldValue("categoryName", "");
              formik.setFieldValue("commissions", [defaultCommissionRow]); // <-- reset commissions here
            } else if (!!id) {
              const numericId = Number(id);
              getFlightCommissionInfo(numericId);
              setCommissionId(numericId);
            }
          }}
          value={formik.values.category}
          placeholder="Assigned Category"
          options={categoriesList}
          isRequired={true}
          isInvalid={formik.touched.category && Boolean(formik.errors.category)}
          errorText={
            formik.touched.category && formik.errors.category
              ? formik.errors.category
              : ""
          }
          // onBlur={() => formik.setFieldTouched("category", true)}
        />
      </div>
      {formik.values.category === "Add new Category" && (
        <div className="col-md-4">
          <MuiInput
            label="Category Name"
            placeholder="Category Name"
            value={formik.values.categoryName}
            onChange={(e) => formik.setFieldValue("categoryName", e)}
            isRequired={true}
            isInvalid={
              formik.touched.categoryName && Boolean(formik.errors.categoryName)
            }
            errorText={
              formik.touched.categoryName && formik.errors.categoryName
                ? formik.errors.categoryName
                : ""
            }
            onBlur={() => formik.setFieldTouched("categoryName", true)}
          />
        </div>
      )}
      <div className="card mt-3">
        <div className=" scrollable-x-auto">
          <table className="table table-bordered add-commission-error-msg">
            <thead>
              <tr>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Type
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  CRS Name
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Airport
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Category
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Airline
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Cabin
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Flat Type
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Fare Type
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Per(%) Type
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Per(%)
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Flat Adult
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Flat Infant
                </th>
                <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Valid Upto
                </th>
                {/* <th className="min-w-[220px] text-center align-middle min-h-[80px]">
                  Valid For
                </th> */}
                <th className="min-w-[150px] text-center align-middle min-h-[80px]">
                  Click
                </th>
                {formik.values.category !== "Add new Category" && (
                  <th className="min-w-[100px] text-center align-middle min-h-[80px]">
                    Actions
                  </th>
                )}
                <th className="min-w-[100px] text-center align-middle min-h-[80px]">
                  Edit
                </th>
              </tr>
            </thead>
            <tbody>
              {formik.values.commissions.map((row: any, index: number) => (
                <tr key={index} className="fareview">
                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.commissionType}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].commissionType`,
                          value
                        )
                      }
                      options={categoryType}
                      placeholder="Type"
                      label="Type"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew
                      }
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.commissionType &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            commissionType?: string;
                          }
                        )?.commissionType
                          ? (
                              formik.errors.commissions?.[index] as {
                                commissionType?: string;
                              }
                            ).commissionType
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.commissionType &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  commissionType?: string;
                                }
                              )?.commissionType
                            : ""
                        )
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.crsName}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].crsName`,
                          value
                        )
                      }
                      options={CRSName}
                      placeholder="CRS Name"
                      label="CRS Name"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.crsName &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            crsName?: string;
                          }
                        )?.crsName
                          ? (
                              formik.errors.commissions?.[index] as {
                                crsName?: string;
                              }
                            ).crsName
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.crsName &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  crsName?: string;
                                }
                              )?.crsName
                            : ""
                        )
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model commission-error">
                    <MuiSearchSelect
                      value={row.airport}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].airport`,
                          value
                        )
                      }
                      options={AirportType}
                      placeholder="Airport"
                      label="Airport"
                      isRequired={true}
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      isInvalid={
                        !!formik.touched.commissions?.[index]?.airport &&
                        !!(formik.errors.commissions?.[index] as any)?.airport
                      }
                      errorText={
                        formik.touched.commissions?.[index]?.airport &&
                        (formik.errors.commissions?.[index] as any)?.airport
                          ? String(
                              (formik.errors.commissions?.[index] as any)
                                ?.airport
                            )
                          : ""
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.airportCategory}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].airportCategory`,
                          value
                        )
                      }
                      options={Category}
                      placeholder="Category"
                      label="Category"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.airportCategory &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            airportCategory?: string;
                          }
                        )?.airportCategory
                          ? (
                              formik.errors.commissions?.[index] as {
                                airportCategory?: string;
                              }
                            ).airportCategory
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.airportCategory &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  airportCategory?: string;
                                }
                              )?.airportCategory
                            : ""
                        )
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model airline-error-msg">
                    <MuiMultiSelect
                      label="Select Airlines"
                      value={row.airlineCodes}
                      options={airlineOptions[index] || []}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].airlineCodes`,
                          value
                        )
                      }
                      inputValue={airlineSearch[index] || ""}
                      onSearchInputChange={(val) => {
                        setAirlineSearch((prev) => ({
                          ...prev,
                          [index]: val,
                        }));
                      }}
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      placeholder="Select Airlines"
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.airlineCodes &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            airlineCodes?: string;
                          }
                        )?.airlineCodes
                          ? (
                              formik.errors.commissions?.[index] as {
                                airlineCodes?: string;
                              }
                            ).airlineCodes
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.airlineCodes &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  airlineCodes?: string;
                                }
                              )?.airlineCodes
                            : ""
                        )
                      }
                    />
                  </td>

                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.cabin}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].cabin`,
                          value
                        )
                      }
                      options={flightClass}
                      placeholder="Cabin"
                      label="Cabin"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.cabin &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            cabin?: string;
                          }
                        )?.cabin
                          ? (
                              formik.errors.commissions?.[index] as {
                                cabin?: string;
                              }
                            ).cabin
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.cabin &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  cabin?: string;
                                }
                              )?.cabin
                            : ""
                        )
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.flatType}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].flatType`,
                          value
                        )
                      }
                      options={flatType}
                      placeholder="Flat Type"
                      label="Flat Type"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.flatType &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            flatType?: string;
                          }
                        )?.flatType
                          ? (
                              formik.errors.commissions?.[index] as {
                                flatType?: string;
                              }
                            ).flatType
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.flatType &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  flatType?: string;
                                }
                              )?.flatType
                            : ""
                        )
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.fareType}
                      onChange={(value) => {
                        formik.setFieldValue(
                          `commissions[${index}].fareType`,
                          value
                        );
                        if (value === "Flat Fare") {
                          formik.setFieldValue(`commissions[${index}].per`, "");
                          formik.setFieldValue(
                            `commissions[${index}].perType`,
                            ""
                          );
                        } else {
                          formik.setFieldValue(
                            `commissions[${index}].adultChildValue`,
                            ""
                          );
                          formik.setFieldValue(
                            `commissions[${index}].infantValue`,
                            ""
                          );
                        }
                      }}
                      options={fareType}
                      placeholder="Fare Type"
                      label="Fare Type"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                      isRequired={true}
                      errorText={
                        formik.touched.commissions?.[index]?.fareType &&
                        typeof formik.errors.commissions?.[index] ===
                          "object" &&
                        (
                          formik.errors.commissions?.[index] as {
                            fareType?: string;
                          }
                        )?.fareType
                          ? (
                              formik.errors.commissions?.[index] as {
                                fareType?: string;
                              }
                            ).fareType
                          : ""
                      }
                      isInvalid={
                        formik.touched.commissions?.[index]?.fareType &&
                        Boolean(
                          typeof formik.errors.commissions?.[index] === "object"
                            ? (
                                formik.errors.commissions?.[index] as {
                                  fareType?: string;
                                }
                              )?.fareType
                            : ""
                        )
                      }
                    />
                  </td>

                  <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.perType}
                      onChange={(value) => {
                        formik.setFieldValue(
                          `commissions[${index}].perType`,
                          value
                        );
                      }}
                      options={percentageType}
                      placeholder="% Type"
                      disabled={
                        (formik.values.category !== "Add new Category" &&
                          !row.isNew &&
                          editingRowIndex !== index) ||
                        row.fareType === "Flat Fare"
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model">
                    <MuiInput
                      value={row.per}
                      placeholder="Per(%)"
                      onChange={(e) => {
                        formik.setFieldValue(`commissions[${index}].per`, e);
                      }}
                      // onBlur={() =>
                      //   formik.setFieldTouched(
                      //     `commissions[${index}].per`,
                      //     true
                      //   )
                      // }
                      disabled={
                        (formik.values.category !== "Add new Category" &&
                          !row.isNew &&
                          editingRowIndex !== index) ||
                        row.fareType === "Flat Fare"
                      }
                      // isInvalid={
                      //   !!formik.touched?.commissions?.[index]?.per &&
                      //   !!(formik.errors?.commissions?.[index] as any)?.per
                      // }
                      // errorText={
                      //   formik.touched?.commissions?.[index]?.per &&
                      //   (formik.errors?.commissions?.[index] as any)?.per
                      //     ? String(
                      //         (formik.errors?.commissions?.[index] as any)
                      //           .per
                      //       )
                      //     : ""
                      // }
                    />
                  </td>

                  <td className="align-middle text-center user-manage-model">
                    <MuiInput
                      value={row.adultChildValue}
                      placeholder="Flat Adult"
                      onChange={(e) => {
                        formik.setFieldValue(
                          `commissions[${index}].adultChildValue`,
                          e
                        );
                      }}
                      disabled={
                        (formik.values.category !== "Add new Category" &&
                          !row.isNew &&
                          editingRowIndex !== index) ||
                        row.fareType === "Percent fare"
                      }
                      isInvalid={
                        !!formik.touched?.commissions?.[index]
                          ?.adultChildValue &&
                        !!(formik.errors?.commissions?.[index] as any)
                          ?.adultChildValue
                      }
                      errorText={
                        formik.touched?.commissions?.[index]?.adultChildValue &&
                        (formik.errors?.commissions?.[index] as any)
                          ?.adultChildValue
                          ? String(
                              (formik.errors?.commissions?.[index] as any)
                                .adultChildValue
                            )
                          : ""
                      }
                    />
                  </td>
                  <td className="align-middle text-center user-manage-model">
                    <MuiInput
                      value={row.infantValue}
                      placeholder="Flat Infant"
                      onChange={(e) => {
                        formik.setFieldValue(
                          `commissions[${index}].infantValue`,
                          e
                        );
                      }}
                      disabled={
                        (formik.values.category !== "Add new Category" &&
                          !row.isNew &&
                          editingRowIndex !== index) ||
                        row.fareType === "Percent fare"
                      }
                      isInvalid={
                        !!formik.touched?.commissions?.[index]?.infantValue &&
                        !!(formik.errors?.commissions?.[index] as any)
                          ?.infantValue
                      }
                      errorText={
                        formik.touched?.commissions?.[index]?.infantValue &&
                        (formik.errors?.commissions?.[index] as any)
                          ?.infantValue
                          ? String(
                              (formik.errors?.commissions?.[index] as any)
                                .infantValue
                            )
                          : ""
                      }
                    />
                  </td>

                  <td className="align-middle text-center user-manage-model">
                    <MuiDatePicker
                      label="Valid Upto"
                      value={row.validUpto ? dayjs(row.validUpto) : null}
                      onChange={(value) => {
                        formik.setFieldValue(
                          `commissions[${index}].validUpto`,
                          value
                        );
                        formik.setFieldValue(
                          `commissions[${index}].dateValidation.travelValidTo`,
                          value
                        );
                      }}
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                    />
                  </td>
                  {/* <td className="align-middle text-center user-manage-model">
                    <MuiSearchSelect
                      value={row.validFor}
                      onChange={(value) =>
                        formik.setFieldValue(
                          `commissions[${index}].validFor`,
                          value
                        )
                      }
                      options={validFor}
                      placeholder="Valid For"
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                    />
                  </td> */}
                  <td className="align-middle text-center user-manage-model ">
                    <button
                      onClick={() => handleOpen(index)}
                      // className="otherOptions-btn others-btn"
                      className={`${
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                          ? "others-btn-disabled  cursor-not-allowed"
                          : "otherOptions-btn others-btn"
                      }`}
                      disabled={
                        formik.values.category !== "Add new Category" &&
                        !row.isNew &&
                        editingRowIndex !== index
                      }
                    >
                      <span>More </span>
                    </button>
                  </td>
                  {formik.values.category !== "Add new Category" && (
                    <td className="d-flex mt-2">
                      {/* <button
                        className={`w-15 h-8 rounded-lg px-3 py-1 text-light flex items-center justify-center text-sm border-none
                              ${
                                index !== formik.values.commissions.length - 1
                                  ? "bg-gray-400 cursor-not-allowed"
                                  : "bg-success bg-light-gradient"
                              }`}
                        onClick={handleAddRow}
                        type="button"
                        disabled={
                          index !== formik.values.commissions.length - 1
                        }
                      >
                        Add
                      </button> */}
                      {index === formik.values.commissions.length - 1 && (
                        <button
                          title="Add Commission"
                          className="btn btn-sm btn-success px-3"
                          onClick={handleAddRow}
                          type="button"
                        >
                          Add
                        </button>
                      )}

                      {formik.values.commissions.length > 1 && (
                        <button
                          title="Remove Commission"
                          className="btn btn-sm btn-danger px-3 ms-2"
                          onClick={() => {
                            setRowToDelete({ id: row.id, index });
                            setShowRejectConfirmation(true);
                          }}
                          type="button"
                        >
                          Remove
                        </button>
                      )}
                    </td>
                  )}
                  <td className="">
                    {row.isNew || editingRowIndex === index ? (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          submitRowIndexRef.current = index;
                          formik.handleSubmit();
                        }}
                        type="button"
                      >
                        Submit
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-primary px-3"
                        onClick={() => setEditingRowIndex(index)}
                        type="button"
                      >
                        Edit
                      </button>
                    )}
                  </td>

                  <ConfirmationModal
                    onConfirm={() => {
                      setCheckValidAirport(false);
                    }}
                    handleClose={() => {
                      setCheckValidAirport(false);
                    }}
                    header="Please Select Valid Airport Type."
                    isVisible={checkValidAirport}
                    buttonText="Ok"
                  />

                  <UserListFilter
                    header={"Advance Configuration"}
                    children={
                      <CMFilterPopUp
                        index={popupIndex}
                        flightOptions={flightOptions}
                        setOpen={setOpen}
                      />
                    }
                    isVisible={open && popupIndex === index}
                    handleClose={() => handleClose()}
                  />
                </tr>
              ))}
            </tbody>
          </table>
          <ConfirmationModal
            onConfirm={() => {
              if (rowToDelete) {
                const { id, index } = rowToDelete;
                if (
                  formik.values.category !== "Add new Category" &&
                  !formik.values.commissions[index].isNew
                ) {
                  removeCommissionRow(id, index);
                } else {
                  handleRemoveRow(index);
                }
                setRowToDelete(null); // cleanup
              }
              setShowRejectConfirmation(false);
            }}
            handleClose={() => {
              setShowRejectConfirmation(false);
              setRowToDelete(null);
            }}
            header="Are you sure you want to remove commission ?"
            isVisible={showRejectConfirmation}
          />
        </div>
      </div>
    </div>
  );
};
